import { hasShopifyAuthParams } from "./shopifyAuth";

const LAST_APP_ROUTE_KEY = "partfinder:last-app-route";
const DEFAULT_APP_ROUTE = "/dashboard";

const normalizePath = (pathname: string) => {
    const normalized = pathname || DEFAULT_APP_ROUTE;
    if (normalized === "/") return DEFAULT_APP_ROUTE;
    return normalized.endsWith("/") && normalized.length > 1
        ? normalized.slice(0, -1)
        : normalized;
};

const isRememberableAppRoute = (pathname: string) => {
    const normalized = normalizePath(pathname);

    return (
        normalized !== "/storefront" &&
        normalized !== "/login" &&
        normalized !== "/not-found" &&
        normalized !== "/server-error" &&
        !normalized.startsWith("/exit-iframe") &&
        !normalized.startsWith("/pf-console") &&
        !normalized.startsWith("/pf-preview")
    );
};

export const rememberLastAppRoute = (pathname: string, search = "", hash = "") => {
    if (hasShopifyAuthParams(search)) return;
    if (!isRememberableAppRoute(pathname)) return;

    sessionStorage.setItem(LAST_APP_ROUTE_KEY, `${normalizePath(pathname)}${search}${hash}`);
};

export const getLastAppRoute = () => {
    const storedRoute = sessionStorage.getItem(LAST_APP_ROUTE_KEY);
    if (!storedRoute) return DEFAULT_APP_ROUTE;

    const pathOnly = storedRoute.split(/[?#]/)[0];
    return isRememberableAppRoute(pathOnly) ? storedRoute : DEFAULT_APP_ROUTE;
};
